// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import { RUNNER_ACTIONS_KEY } from '../../commons/RunnerConstants';

export const dispatchCreateRunner = (organizationId, workspaceId, runner) => ({
  type: RUNNER_ACTIONS_KEY.TRIGGER_SAGA_CREATE_RUNNER,
  organizationId,
  workspaceId,
  runner,
});

export const dispatchCreateDatastoreAndRunners = (organizationId, workspaceId, dataset) => ({
  type: RUNNER_ACTIONS_KEY.TRIGGER_SAGA_CREATE_DATASTORE_AND_RUNNERS,
  organizationId,
  workspaceId,
  dataset,
});

export const dispatchUpdateDatastoreAssociatedRunners = (organizationId, workspaceId, datasetId, newRuns) => ({
  type: RUNNER_ACTIONS_KEY.TRIGGER_SAGA_UPDATE_DATASTORE_ASSOCIATED_RUNNERS,
  organizationId,
  workspaceId,
  datasetId,
  newRuns,
});

export const dispatchStopRunner = (organizationId, workspaceId, datasetId) => ({
  type: RUNNER_ACTIONS_KEY.TRIGGER_SAGA_STOP_RUNNER,
  organizationId,
  workspaceId,
  datasetId,
});

export const dispatchUpdateRunner = (organizationId, workspaceId, runnerId, datasetId, runnerPatch) => ({
  type: RUNNER_ACTIONS_KEY.TRIGGER_SAGA_UPDATE_RUNNER,
  organizationId,
  workspaceId,
  runnerId,
  datasetId,
  runnerPatch,
});
